import { HttpContextToken } from '@angular/common/http';

/**
 * Opt a request out of all auth handling: no Bearer injection, no 401 refresh, no logout-on-failure.
 * Use for public content assets (e.g. library media fetched during an unauthenticated preview) that
 * must never bounce the user to the login screen when no session exists.
 *
 * Kept in a dependency-free module so callers can flag a request without pulling in the interceptor's
 * (and transitively AuthService's) heavy imports.
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
